// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ComboRelatorios_UnidadeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de GET /so/combo_relatorios/unidade (NS 2026-0090, fatia 4): os
 * combos da unidade no periodo (vendas, usos) e o saldo de agora, a soma e
 * os movimentos do periodo. Valores em centavos.
 */
import type { ComboRelatorios_MovimentoRow } from './ComboRelatorios_MovimentoRow'
import type { ComboRelatorios_UnidadeComboRow } from './ComboRelatorios_UnidadeComboRow'
import type { ComboRelatorios_UnidadeTotaisRow } from './ComboRelatorios_UnidadeTotaisRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ComboRelatorios_UnidadeResponseDados {
franquia_id: number
data_inicio: string
data_fim: string
combos: ComboRelatorios_UnidadeComboRow[]
totais: ComboRelatorios_UnidadeTotaisRow
movimentos: ComboRelatorios_MovimentoRow[]
}

export type ComboRelatorios_UnidadeResponse = ApiResponse<ComboRelatorios_UnidadeResponseDados>;

registerResponseContract('ComboRelatorios_UnidadeResponse', {
  franquia_id: { type: 'number',  required: true },
  data_inicio: { type: 'string',  required: true },
  data_fim:    { type: 'string',  required: true },
  combos: {
    type: 'array',
    required: true,
    items: {
      combo_id:         { type: 'number',  required: true },
      combo_nome:       { type: 'string',  required: true },
      vendidos:         { type: 'number',  required: true },
      valor_vendido:    { type: 'number',  required: true },
      cancelados:       { type: 'number',  required: true },
      valor_cancelado:  { type: 'number',  required: true },
      pares_usados:     { type: 'number',  required: true },
      estornos:         { type: 'number',  required: true },
      ajustes_credito:  { type: 'number',  required: true },
      ajustes_debito:   { type: 'number',  required: true },
      pares_cancelados: { type: 'number',  required: true },
      compras_ativas:   { type: 'number',  required: true },
      saldo_disponivel: { type: 'number',  required: true },
      saldo_vencido:    { type: 'number',  required: true },
      saldo_reservado:  { type: 'number',  required: true },
    },
  },
  totais: {
    type: 'object',
    required: true,
    fields: {
      vendidos:         { type: 'number',  required: false },
      valor_vendido:    { type: 'number',  required: false },
      cancelados:       { type: 'number',  required: false },
      valor_cancelado:  { type: 'number',  required: false },
      pares_usados:     { type: 'number',  required: false },
      estornos:         { type: 'number',  required: false },
      ajustes_credito:  { type: 'number',  required: false },
      ajustes_debito:   { type: 'number',  required: false },
      pares_cancelados: { type: 'number',  required: false },
      compras_ativas:   { type: 'number',  required: false },
      saldo_disponivel: { type: 'number',  required: false },
      saldo_vencido:    { type: 'number',  required: false },
      saldo_reservado:  { type: 'number',  required: false },
    },
  },
  movimentos: {
    type: 'array',
    required: true,
    items: {
      movimento_id:        { type: 'number',  required: true },
      compra_id:           { type: 'number',  required: true },
      combo_id:            { type: 'number',  required: true },
      combo_nome:          { type: 'string',  required: true },
      cliente_id:          { type: 'number',  required: true },
      cliente_nome:        { type: 'string',  required: true },
      tipo:                { type: 'string',  required: true },
      quantidade:          { type: 'number',  required: true },
      order_id:            { type: 'number',  required: false },
      order_item_id:       { type: 'number',  required: false },
      preco_matriz:        { type: 'number',  required: false },
      origem_movimento_id: { type: 'number',  required: false },
      motivo:              { type: 'string',  required: false },
      usuario_id:          { type: 'string',  required: false },
      created_at:          { type: 'string',  required: true },
    },
  },
})
